import { css } from 'styled-components';

export const content = () => css`
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;
`;
